export const roundNumber = (value: number, decimalPlaces: number = 3) => {
  const numberWithDecimalPlaces = value.toString().includes('.');

  const factor = Math.pow(10, decimalPlaces);
  return numberWithDecimalPlaces ? Number((Math.floor(value * factor) / factor).toFixed(decimalPlaces)) : value;
};
